
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#000","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M37.49 44.63c0 .986-.8 1.786-1.786 1.786H5.356c-.986 0-1.786-.8-1.786-1.786V14.282c0-.986.8-1.786 1.786-1.786h30.348c.986 0 1.786.8 1.786 1.786V44.63zM35.704 8.926H5.356A5.356 5.356 0 000 14.282V44.63a5.356 5.356 0 005.356 5.356h30.348a5.356 5.356 0 005.356-5.356V14.282a5.356 5.356 0 00-5.356-5.356z"}}),_c('path',{attrs:{"d":"M44.63 0H12.497A5.356 5.356 0 007.14 5.356a1.785 1.785 0 103.57 0c0-.986.8-1.786 1.786-1.786H44.63c.986 0 1.786.8 1.786 1.786V37.49c0 .986-.8 1.785-1.786 1.785a1.785 1.785 0 100 3.57 5.356 5.356 0 005.356-5.355V5.356A5.356 5.356 0 0044.63 0"}}),_c('path',{attrs:{"d":"M20 19.75c.414 0 .79.168 1.06.44.272.27.44.646.44 1.06h0v7.249l7.25.001c.414 0 .79.168 1.06.44a1.495 1.495 0 010 2.121c-.27.271-.646.439-1.06.439h0l-7.25-.001v7.251c0 .414-.168.79-.44 1.06a1.495 1.495 0 01-2.121 0 1.495 1.495 0 01-.439-1.06h0v-7.251l-7.25.001c-.414 0-.79-.168-1.06-.44A1.495 1.495 0 019.75 30c0-.414.168-.79.44-1.06.27-.272.646-.44 1.06-.44h0l7.25-.001V21.25c0-.414.168-.79.44-1.06.27-.272.646-.44 1.06-.44z","stroke":"#000","stroke-width":".5","stroke-linejoin":"round"}})])])
          )
        }
      }
    